
$(document).ready(function () {
    console.log("mobilefilter loads");

    $('.mobilefilter').click(function () {
      //$('#collectionFilters').toggle('slow');
      $("#collectionFilters, .popup-content").addClass("active");
    });

    $('.popup-overlay').click(function () {
      $("#collectionFilters, .popup-content").removeClass("active");
    });

  });
  $(function () {
    //caches a jQuery object containing the header element
    var header = $(".product-topbox");
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();

      if (scroll >= 350) {
        header.addClass("fixedbox");
      } else {
        header.removeClass("fixedbox");
      }
    });
  }); 